import type { ReactNode } from 'react'

interface HardwareResultBarProps {
  status: string
  queuePosition?: number | null
  errorMessage?: string | null
  onDismiss?: () => void
  children?: ReactNode  // Domain-specific metric display (LER, Fidelity, etc.)
}

export default function HardwareResultBar({
  status,
  queuePosition,
  errorMessage,
  onDismiss,
  children,
}: HardwareResultBarProps) {
  return (
    <div className="flex-shrink-0 border-b border-qcloud-border bg-blue-50 px-4 py-2 flex items-center gap-4 text-xs">
      <span className="font-semibold text-qcloud-text">Hardware:</span>
      <span className={`font-semibold ${
        status === 'completed' ? 'text-green-600' :
        status === 'failed' ? 'text-red-500' :
        status === 'running' ? 'text-blue-600' :
        'text-amber-600'
      }`}>
        {status}
        {status === 'running' && <span className="inline-block w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse ml-1 align-middle" />}
      </span>
      {queuePosition != null && queuePosition > 0 && (
        <span className="text-qcloud-muted">Queue #{queuePosition}</span>
      )}
      {children}
      {errorMessage && (
        <span className="text-red-500 truncate max-w-xs" title={errorMessage}>{errorMessage}</span>
      )}
      <div className="flex-1" />
      {onDismiss && (
        <button onClick={onDismiss} className="text-qcloud-muted hover:text-red-400 text-[10px]">dismiss</button>
      )}
    </div>
  )
}
